import { useQuery } from "@tanstack/react-query";
import api from "../config/axiosConfig";
import { useSelector } from "react-redux";

//Hook para cacheLoader
export const fetchInvalidaciones = async (id_empresa) => {
  if (!id_empresa) {
    console.warn("⚠️ `id_empresa` no es válido en fetchTerceros:", id_empresa);
    return [];
  }

  try {
    const response = await api.get(`/${id_empresa}/invalidaciones`);
    return response.data;
  } catch (error) {
    console.error("❌ Error en la petición:", error);
    return [];
  }
};

// Hook reutilizable con React Query
export const useInvalidaciones = () => {
  const { empresaSeleccionada } = useSelector((state) => state.auth);
  const id_empresa = empresaSeleccionada?.id; // ✅ Asegurar que existe un `id_empresa`

  return useQuery({
    queryKey: ["invalidaciones", id_empresa],
    queryFn: () => (id_empresa ? fetchInvalidaciones(id_empresa) : Promise.resolve([])),
    enabled: !!id_empresa,
  });
};
